import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=53e907fd&scoped=true&"
import script from "./AvatarComponent.vue?vue&type=script&lang=js&"
export * from "./AvatarComponent.vue?vue&type=script&lang=js&"
import style0 from "./AvatarComponent.vue?vue&type=style&index=0&id=53e907fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e907fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBadge,VTooltip})
